<template lang="html">
  <div class="product-group-container-wrapper">
    <div class="product-group-container">
      <WardrobeEmptyState
        :layer-display-name="layerDisplayName"
        v-if="filteredWardrobeProducts.length === 0"
      />
      <product
        v-for="wp in filteredWardrobeProducts"
        :key="wp.id"
        :wardrobe-product="wp"
        v-else
      />
    </div>
  </div>
</template>

<script>
import CapsuleUtils from "@/utils/CapsuleUtils";
import Product from "@/components/capsuleBuilder/modals/addProductModal/Product";
import WardrobeEmptyState from "@/components/capsuleBuilder/modals/addProductModal/WardrobeEmptyState";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    Product,
    WardrobeEmptyState,
  },

  props: {
    layerDisplayName: {
      type: String,
      required: true,
    },
  },

  created() {
    this.getGroupName = CapsuleUtils.getGroupName;
  },

  mounted() {
    if (
      !this.wardrobeDataStates.products.fetching &&
      !this.wardrobeDataStates.products.loaded
    ) {
      this.fetchWardrobeProducts(this.currentUser.wardrobe_id).then(() => {
        this.filteredWardrobeProducts = this.filterAndSortWardrobeProducts();
      });
    } else {
      this.filteredWardrobeProducts = this.filterAndSortWardrobeProducts();
    }
  },

  data() {
    return {
      filteredWardrobeProducts: [],
    };
  },

  computed: {
    ...mapGetters(["currentUser", "wardrobeDataStates", "wardrobeProducts"]),
  },

  methods: {
    ...mapActions(["fetchWardrobeProducts"]),

    filterAndSortWardrobeProducts() {
      let layerGroupName = this.getGroupName(this.layerDisplayName);
      let isLayerTopGroup = ["outerwear", "midwear", "innerwear"].includes(
        layerGroupName
      );

      let items = this.wardrobeProducts.filter((wp) => {
        return isLayerTopGroup
          ? ["outerwear", "midwear", "innerwear"].includes(wp.group)
          : wp.group === layerGroupName;
      });

      return isLayerTopGroup ? this.sortWardrobeProducts(items) : items;
    },

    sortWardrobeProducts(items) {
      return items.sort(function (a, b) {
        let nameA = a.group.toUpperCase(); // ignore upper and lowercase
        let nameB = b.group.toUpperCase(); // ignore upper and lowercase

        if (nameA > nameB) return -1;
        if (nameA < nameB) return 1;
        return 0; // names must be equal
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.product-group-container-wrapper {
  overflow-x: hidden;
}

.product-group-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-left: -1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/capsuleBuilder/modals/addProductModal/FromWardrobe.vue